import businessDivision from "../data/businessDivision";

const palette = {
    green1: "#9FE870",
    businessDivisionColors: {
        acceleration: '#9FE870',
        disruption: '#0AE1FF',
        expansion: '#7D72FF'
    }
}

export default palette;